
import app from 'flarum/forum/app';
import listItems from 'flarum/common/helpers/listItems';
import LinkModal from './LinkModal';
import Button from 'flarum/common/components/Button';
export default class UpdateAlert {
  HideAlert() {
    const user = app.session.user;
    if(!user){
      return true;
    }
    return user.data.attributes.SMSAuth.isAuth;
  }

  view(){
    if (this.HideAlert()) {
      return m('div');
    }

    const controls = [
      Button.component(
        {
          className: 'Button Button--primary SMSAuthRestrictionAlertAction',
          icon: 'fas fa-mobile-alt',
          onclick: () => {
            app.drawer.hide();
            // On phones, the drawer closes with an animation. Opening the modal
            // on the next tick made it render inside that full-height drawer.
            window.setTimeout(() => app.modal.show(LinkModal), 180);
          },
        },
        app.translator.trans('lakevy-phone-binding.forum.alerts.toLink')
      ),
    ];
    const dismissControl = [];
    return m(
        '.Alert.Alert-info.SMSAuthRestrictionAlert',
        m('.container', [
          m(
            'span.Alert-body', app.translator.trans(`lakevy-phone-binding.forum.alerts.limit`)
          ),
          m('ul.Alert-controls',  listItems(controls.concat(dismissControl))),
        ])
    );
  }
    
}
